import styled from '@emotion/styled';
import { BasicFlex } from '../../../../utils/Common';

import { useQuery } from '@tanstack/react-query';

import useSimpleTable from '../../../../hooks/useSimpleTable';

import SimplePagination from '../../../../utils/utilities/SimplePagination';

import useReportStore from '../../../../store/reports';

import { isEmpty } from 'lodash';

import SimpleTableComponent from '../../../../utils/utilities/SimpleTable';

import SimpleChip from '../../../../utils/utilities/SimpleChip';

import { startCase } from 'lodash';

import { formatCurrency, formatGenericDate } from '../../../../utils/util';

const ListTitle = styled.div`
  font-weight: 600;
  color: ${props => props.theme.colors.mildText};
  margin-bottom: 1rem;
  text-transform: uppercase;
  font-size: 1.2rem;
  margin-top: .5rem;
`

const HeaderRow = styled(BasicFlex)`
  padding: 0 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  font-weight: 700;
  

  div {
    display: flex;
    justify-content: flex-start;
    flex-basis: 0;
    flex-grow: 1;
    /* width: 12rem; */
    padding: .5rem 1rem;
    text-transform: uppercase;
    font-size: 1.2rem;
    color: ${props => props.theme.colors.mildText};
  }
`

const BodyRow = styled(BasicFlex)`
  padding: 0 1rem;
  

  div {
    display: flex;
    justify-content: flex-start;
    padding: 1rem;
    flex-basis: 0;
    flex-grow: 1;
    /* width: 12rem; */
  }

  /* .right {
    justify-content: right;
  } */
`
const Container = styled.div`
  flex-grow: 1;
`
const headers = [
  {
    label: "Invoice #",
    id: "invoice_num"
  }, 
  {
    label: "Date",
    id: "date",
    dateShort: true
  }, 
  {
    label: "Customer",
    id: "customer_name"
  }, 
  {
    label: "Total",
    id: "revenue",
    currency: true
  },  
  {
    label: "Profit",
    id: "profit",
    currency: true
  },
  {
    label: "Paid",
    id: "paid",
    currency: true
  },
  {
    label: "Sales Rep",
    id: "sales_rep",
    render: row => row.sales_rep ? <SimpleChip label={row.sales_rep} /> : ''
  },
  {
    label: "Invoice Total",
    id: "invoice_total",
    currency: true
  }
]

const Subcomponent = ({ row }) => {
  return (
    <>
    <ListTitle>Invoice Line Items</ListTitle>
    <HeaderRow justifyContent="space-between">
        <div>Num</div>
        <div>Item</div>
        <div>Description</div>
        <div>Category</div>
        <div>Qty</div>
        <div>Total</div>
        <div>Cost</div>
        <div className="right">Profit</div>
      </HeaderRow>
    {row.line_items?.map((item, index) => (
      <BodyRow key={index} justifyContent="space-between">
        <div>{index + 1})</div>
        <div>{item.name}</div>
        <div>{item.description || '-'}</div>
        <div>{startCase(item.category)}</div>
        <div>{item.quantity}</div>
        <div>{formatCurrency(item.revenue)}</div>
        <div>{formatCurrency(item.cogs)}</div>
        <div className="right">{formatCurrency(item.profit)}</div>
      </BodyRow>
    ))}
    </>
  )
}

const InvoiceList = ({ category }) => {
  const reportType = useReportStore(state => state.reportType);
  const filterString = useReportStore(state => state.filterString[reportType]);
  const staticFilterString = useReportStore(state => state.staticFilterString[reportType]);
  const reportResults = useReportStore(state => state.reportResults);


  let finalString = category ? `&[ignore][category]=${category}${filterString}` : filterString;

  if (staticFilterString) finalString += `&${staticFilterString}`

  const results = reportResults[reportType];
  let totals = results?.totals || {};

  const { data: list, pagination, setPagination, isLoading } = useSimpleTable({url: `/reports/${reportType}/detailed`, filterString: finalString, enabled: !isEmpty(totals)});

  console.log(list, "list");

  return (
  <Container>

  <SimpleTableComponent url="invoices" headers={headers} rows={list?.rows || []} idKey="invoice_id" isLoading={isLoading} Subcomponent={Subcomponent}  />

  <SimplePagination currentPage={pagination?.page} resultCount={list?.count} rowsPerPage={pagination?.rowsPerPage} results={list?.rows} setPagination={setPagination} />
  </Container>
  )

};

export default InvoiceList;